import React, { createContext, useContext } from 'react';
import { auth, db, storage, analytics } from '../firebase/config';

const FirebaseContext = createContext();

export const FirebaseProvider = ({ children }) => {
  const value = {
    auth,
    db,
    storage,
    analytics
  };

  return (
    <FirebaseContext.Provider value={value}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => {
  const context = useContext(FirebaseContext);
  if (!context) {
    throw new Error('useFirebase must be used within a FirebaseProvider');
  }
  return context;
};

